module.exports = __webpack_public_path__ + "img/Rustic_chic.e949dc0.jpg";